import React from 'react';
import { useDispatch } from 'react-redux';
import { NavTextButton } from '../../components/NavBar';
import { displayConfirmationAlert, displayInformationAlert } from '../../helpers/Functions';
import { shiftLogActions } from '../../store';
import { AppDispatch } from '../../store/store';

interface SubmitButtonProps {
  onSuccess?: () => void;
}

const SubmitButton = ({ onSuccess }: SubmitButtonProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const displaySuccessAlert = () => {
    displayInformationAlert({
      title: 'Successfully Submitted',
      description: 'The shift log has been successfully submitted.',
      onOk: () => onSuccess && onSuccess(),
    });
  };

  const handleSubmitPressed = () => {
    displayConfirmationAlert({
      title: 'Confirm Submission',
      description: 'Are you sure you want to submit the shift log?',
      onConfirm: async () => {
        const action = await dispatch(shiftLogActions.submitShiftLog());
        if (shiftLogActions.submitShiftLog.fulfilled.match(action)) {
          onSuccess?.();
          displaySuccessAlert();
        }
      },
    });
  };

  return <NavTextButton text="Submit" onPress={handleSubmitPressed} />;
};

export default SubmitButton;
